// Common file extensions accepted for uploads
export const ALL_EXTENSIONS = [
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.csv',
  '.txt',
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
].join(',')

// Private S3 bucket type for secure file uploads
export const PRIVATE_S3_BUCKET_TYPE = 'private'
